var map = {
	"./img/G1_V1.png": "nvFc",
	"./img/G1_V1_cut.png": "rq9t",
	"./img/G1_V2.png": "djV6",
	"./img/G1_V2_cut.png": "VOM9",
	"./img/G1_V3.png": "RUIW",
	"./img/G1_V3_cut.png": "p5Vz",
	"./img/G1_V4.png": "7IAb",
	"./img/G1_V4_cut.png": "fSR3",
	"./img/G2_V1.png": "aMN/",
	"./img/G2_V1_cut.png": "xDO4",
	"./img/G2_V2.png": "Ir/G",
	"./img/G2_V2_cut.png": "8unq",
	"./img/G2_V3.png": "Y/0S",
	"./img/G2_V3_cut.png": "gSLn",
	"./img/G2_V4.png": "tydN",
	"./img/G2_V4_cut.png": "8Go5",
	"./img/G3_V1.png": "Mlrw",
	"./img/G3_V1_cut.png": "feAg",
	"./img/G3_V2.png": "gYgQ",
	"./img/G3_V2_cut.png": "kN25",
	"./img/G3_V3.png": "AquF",
	"./img/G3_V3_cut.png": "RZza",
	"./img/G3_V4.png": "JkH5",
	"./img/G3_V4_cut.png": "hQcL",
	"./img/G4_V1.png": "KRA1",
	"./img/G4_V1_cut.png": "aSiC",
	"./img/G4_V2.png": "0kvg",
	"./img/G4_V2_cut.png": "lpqy",
	"./img/G4_V3.png": "afJo",
	"./img/G4_V3_cut.png": "e3Yw",
	"./img/G4_V4.png": "HXxN",
	"./img/G4_V4_cut.png": "V/4P",
	"./img/G5_V1.png": "g1ty",
	"./img/G5_V1_cut.png": "uVH6",
	"./img/G5_V2.png": "iI7h",
	"./img/G5_V2_cut.png": "U8vi",
	"./img/G5_V3.png": "VLL0",
	"./img/G5_V3_cut.png": "Xctk",
	"./img/G5_V4.png": "b1m2",
	"./img/G5_V4_cut.png": "9/62",
	"./img/G6_V1.png": "i06S",
	"./img/G6_V1_cut.png": "395c",
	"./img/G6_V2.png": "t6Xo",
	"./img/G6_V2_cut.png": "/F2x",
	"./img/G6_V3.png": "xLQB",
	"./img/G6_V3_cut.png": "mVKW",
	"./img/G6_V4.png": "QHl4",
	"./img/G6_V4_cut.png": "5s2A",
	"./img/G7_V1.png": "XlNv",
	"./img/G7_V1_cut.png": "25IA",
	"./img/G7_V2.png": "SIrW",
	"./img/G7_V2_cut.png": "YQ13",
	"./img/G7_V3.png": "QCR9",
	"./img/G7_V3_cut.png": "eBRn",
	"./img/G8_V1.png": "J2In",
	"./img/G8_V1_cut.png": "tp1j",
	"./img/G8_V2.png": "ddqn",
	"./img/G8_V2_cut.png": "XEsp",
	"./img/G8_V3.png": "dTZD",
	"./img/G8_V3_cut.png": "JKwT",
	"./img/G8_V4.png": "z55P",
	"./img/G8_V4_cut.png": "koeL",
	"./img/tutorial.png": "NeVG",
	"./img/tutorial_cut.png": "LKql",
	"./img_1024/G1_V1.png": "pWVK",
	"./img_1024/G1_V1_cut.png": "xQ6C",
	"./img_1024/G1_V2.png": "6qww",
	"./img_1024/G1_V2_cut.png": "l8Xn",
	"./img_1024/G1_V3.png": "7p6F",
	"./img_1024/G1_V3_cut.png": "tYKt",
	"./img_1024/G1_V4.png": "nk21",
	"./img_1024/G1_V4_cut.png": "iALF",
	"./img_1024/G2_V1.png": "md5E",
	"./img_1024/G2_V1_cut.png": "3vYW",
	"./img_1024/G2_V2.png": "i6eY",
	"./img_1024/G2_V2_cut.png": "LJpR",
	"./img_1024/G2_V3.png": "fGXE",
	"./img_1024/G2_V3_cut.png": "3Jbi",
	"./img_1024/G2_V4.png": "A6eg",
	"./img_1024/G2_V4_cut.png": "LqkI",
	"./img_1024/G3_V1.png": "qOa4",
	"./img_1024/G3_V1_cut.png": "CBRy",
	"./img_1024/G3_V2.png": "ZOdn",
	"./img_1024/G3_V2_cut.png": "TyXO",
	"./img_1024/G3_V3.png": "nPuU",
	"./img_1024/G3_V3_cut.png": "ZeY0",
	"./img_1024/G3_V4.png": "taYy",
	"./img_1024/G3_V4_cut.png": "dtdH",
	"./img_1024/G4_V1.png": "wBmp",
	"./img_1024/G4_V1_cut.png": "gL45",
	"./img_1024/G4_V2.png": "WYCZ",
	"./img_1024/G4_V2_cut.png": "UgCN",
	"./img_1024/G4_V3.png": "qrmo",
	"./img_1024/G4_V3_cut.png": "42PN",
	"./img_1024/G4_V4.png": "Y2Mz",
	"./img_1024/G4_V4_cut.png": "F8uv",
	"./img_1024/G5_V1.png": "sLuk",
	"./img_1024/G5_V1_cut.png": "oAtN",
	"./img_1024/G5_V2.png": "6QRA",
	"./img_1024/G5_V2_cut.png": "b/9m",
	"./img_1024/G5_V3.png": "Islt",
	"./img_1024/G5_V3_cut.png": "b+ca",
	"./img_1024/G5_V4.png": "if/9",
	"./img_1024/G5_V4_cut.png": "XxrC",
	"./img_1024/G6_V1.png": "rroq",
	"./img_1024/G6_V1_cut.png": "Kkfj",
	"./img_1024/G6_V2.png": "uXnn",
	"./img_1024/G6_V2_cut.png": "X7/2",
	"./img_1024/G6_V3.png": "W0JG",
	"./img_1024/G6_V3_cut.png": "fndd",
	"./img_1024/G6_V4.png": "TBDJ",
	"./img_1024/G6_V4_cut.png": "IvsB",
	"./img_1024/G7_V1.png": "LikQ",
	"./img_1024/G7_V1_cut.png": "zyyW",
	"./img_1024/G7_V2.png": "Azkp",
	"./img_1024/G7_V2_cut.png": "5h68",
	"./img_1024/G7_V3.png": "dNhd",
	"./img_1024/G7_V3_cut.png": "eTfD",
	"./img_1024/G8_V1.png": "H7uZ",
	"./img_1024/G8_V1_cut.png": "tqqU",
	"./img_1024/G8_V2.png": "29d7",
	"./img_1024/G8_V2_cut.png": "pR+2",
	"./img_1024/G8_V3.png": "QtVB",
	"./img_1024/G8_V3_cut.png": "8tXH",
	"./img_1024/G8_V4.png": "TT+M",
	"./img_1024/G8_V4_cut.png": "I7cd",
	"./img_1024/tutorial.png": "mpqj",
	"./img_1024/tutorial_cut.png": "4xBN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "lbb1";


//////////////////
// WEBPACK FOOTER
// ./src/components/captation ^.*\.png$
// module id = lbb1
// module chunks = 1